import { ChartMetadata, ChartType } from '../../../API';

export interface ChartCard {
  type: ChartType;
  title: string;
  subtitle: string;
  icon: string;
  displayConfig?: ChartConfig;
  disabled?: boolean;
  tooltip?: string;
}

export interface ChartConfig {
  chartTitle: boolean;
  xAxisValue?: boolean;
  yAxisValue?: boolean;
  xAxisLabel?: boolean;
  yAxisLabel?: boolean;
  chartColor?: boolean;
  barWidth?: boolean;
  xAxisGridLines?: boolean;
  yAxisGridLines?: boolean;
  pointSize?: boolean;
  category?: boolean;
  categoryValue?: boolean;
  location?: boolean;
  locationValue?: boolean;
  colorPalette?: boolean;
  mapType?: boolean;
}

export interface MetadataColumn {
  label: string;
  name: string;
  type?: string;
}

export const StringAndDateAthenaType = ['varchar', 'char', 'string', 'date', 'timestamp', 'interval'];

export const IntAthenaType = ['tinyint', 'smallint', 'integer', 'int', 'bigint', 'double', 'real', 'float', 'decimal'];

export const OtherAthenaType = ['boolean', 'binary', 'array', 'map', 'row', 'unknown'];

export interface ChartData {
  data: any[];
  type: any;
}

export type DataArrays = Record<string, (string | number)[]>;

export interface ChartMetadataExtended extends ChartMetadata {
  chartDisplayImage?: string;
}

export type ChartDataWithId = Record<string, DataArrays>;
